module.exports = __webpack_public_path__ + "img/sample_ic_back.3312d74f.webp";